exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!@angular/material/prebuilt-themes/deeppurple-amber.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/makebetter/Documents/sportsceneDash/~/postcss-loader?{"ident":"postcss"}!/Users/makebetter/Documents/sportsceneDash/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 3